import { camelCaseToSentenceCase } from 'feature/loading-management/utils/format';

export const activeFilter = value => {
  return {
    label: 'Status',
    name: 'active',
    value,
  };
};
export const authorizationSelectionFilter = value => {
  return {
    label: 'Authorization',
    name: 'authorizationSelection',
    value,
  };
};
export const authorizationSequencingFilter = (value, viewBy) => {
  return {
    label: viewBy === 'product' ? 'Location' : 'Product',
    name: 'nameShort',
    value,
  };
};
export const carrierFilter = value => {
  return { label: 'Carrier', name: 'nameShort', value };
};
export const exchangeFilter = value => {
  return {
    label: 'Exchange',
    name: 'exchange',
    value,
  };
};
export const extendedLoadingSelectionFilter = value => {
  return { label: 'Extended Loading', name: 'extendedLoadingSelection', value };
};
export const inventoryOwnerFilter = value => {
  return { label: 'Inventory Owner', name: 'inventoryOwner', value };
};
export const limitTypeFilter = value => {
  return { label: 'Limit Type', name: 'limitType', value };
};
export const loadingAllowedFilter = value => {
  return {
    label: 'Status',
    name: 'loadingAllowed',
    value: value === 'Any' ? 'Any' : camelCaseToSentenceCase(value),
  };
};
export const typeFilter = value => {
  return { label: 'Type', name: 'type', value };
};
export const statusFilter = value => {
  return { label: 'Status', name: 'status', value };
};
export const supplierFilter = value => {
  return { label: 'Supplier', name: 'supplier', value };
};
export const locationFilter = (value, authorizationType) => {
  return {
    label: 'Location',
    name: authorizationType === 'carrier-authorizations' ? 'nameShort' : 'location',
    value,
  };
};
export const productFilter = value => {
  return {
    label: 'Product',
    name: 'product',
    value,
  };
};
export const stateFilter = value => {
  return {
    label: 'State',
    name: 'state',
    value,
  };
};
